import { render, staticRenderFns } from "./zwgk-door.vue?vue&type=template&id=3e5524b2&"
import script from "./zwgk-door.vue?vue&type=script&lang=js&"
export * from "./zwgk-door.vue?vue&type=script&lang=js&"
import style0 from "./zwgk-door.vue?vue&type=style&index=0&id=3e5524b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports